import { SchedulingAvailabilityComponent } from 'app/components/scheduling-availability/SchedulingAvailabilityComponent'
import { useSchedulingAvailability } from 'app/components/scheduling-availability/useSchedulingAvailability'

export default function Availability() {
  const hookData = useSchedulingAvailability()
  return <SchedulingAvailabilityComponent {...hookData} />
}
